import React, { useState as uState } from 'react'
import { Link } from 'react-router-dom'

import Tel from '../../assets/images/telephone-symbol-button.png'
import Emal from '../../assets/images/email.png'

export default function footer() {
  const [letter, setLetter] = uState({
    email:""
  })
  const handleChange = (e) => {
    e.preventDefault()
    setLetter({
      ...letter,
      [e.target.name] : e.target.value
    })
  }
  const handleLetter = async(e) => {
    if (letter.email === '') {
      alert('user Email is Empty')
    }
    else {

      e.preventDefault()
      const response = await fetch('http://localhost:8000/users/letter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: letter.email,
        })
      })

      const json = await response.json()

      if (!json.success) {
        alert('error in sending data')
      }
      else {
        alert('subscribed')
      }
    }
  }
  return (
    <>
      <section className="info_section layout_padding2 flag2">
    <div className="container">
      <div className="row">
        <div className="col-md-3">
          <div className="info_contact">
            <h4>
              Contact
            </h4>
            <div className="box">
              <div className="img-box">
                <img src={Tel} alt=""/>
              </div>
              <div className="detail-box">
                <h6>
                  +91 9671810274
                </h6>
              </div>
            </div>
            <div className="box">
              <div className="img-box">
                <img src={Emal} alt=""/>
              </div>
              <div className="detail-box">
                <h6>
                  3ppp1m@gmail.com
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="info_menu">
            <h4>
              Menu
            </h4>
            <ul className="navbar-nav  ">
              <li className="nav-item active">
                <Link className="nav-link flag2" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link flag2" to="/about"> About </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link flag2" to="/medici"> Medicine </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link flag2" to="/news"> News </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-6">
          <div className="info_news">
            <h4>
              newsletter
            </h4>
            <form onSubmit={handleLetter}>
              <input required name='email' onChange={handleChange} value={letter.email} type="email" placeholder="Enter Your email"/>
              <div className="d-flex justify-content-center justify-content-md-end mt-3">
                <button type='submit'>
                  Subscribe
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
<section className="container-fluid footer_section">
    <p>
      &copy; 2023 All Rights Reserved. Design by Purav
        </p>
  </section>
</>
  )
}
